import Image from 'next/image'
import Link from 'components/shared/link'

const Logo = ({ config, className = '' }: { config: IDomainConfig; className?: string }) => (
    <Link href='/' className={`relative h-10 w-10 ${className}`}>
        <Image
            src={config.organisation_logo || '/images/logos/disporty-logo.png'}
            fill
            sizes='(max-width: 40px) 100vw, 40px'
            className='object-contain'
            alt='Disporty logo'
        />
    </Link>
)

export default Logo
